<template>
    <div class="cloudscene-view">
        <div class="top-box">
            <el-form :model="paramsFrom" ref="warnform" :inline="true" class="flex flex_ju_sb warnform-inline rb-form"
                :style="{ paddingRight: 0 + 'px' }">
                <div class="form-inputs">
                    <el-form-item label="场景名称" :style="{ marginRight: 40 + 'px' }">
                        <el-input v-model="paramsFrom.sceneName" placeholder="请输入场景名称"></el-input>
                    </el-form-item>
                </div>
                <div class="form-inputs">
                    <el-form-item label="场景状态" :style="{ marginRight: 40 + 'px' }">
                        <el-select placeholder="请选择" v-model="paramsFrom.sceneState">
                            <el-option v-for="(item, index) in collectList" :key="index" :label="item.name"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-form-item class="form-btns" :style="{ marginRight: 0 + 'px' }">
                    <el-button type="primary" @click="searchClick">查询</el-button>
                </el-form-item>
                <el-form-item class="form-btns" :style="{ marginRight: 0 + 'px' }">
                    <div class="cz-btn" @click="resetClick">重置</div>
                </el-form-item>
            </el-form>
        </div>
        <div class="bottom" v-if="dataList.length">
            <div class="bot-top">
                <div class="item" @click="addClick">新增</div>
                <div class="item" @click="openLogs">查看日志</div>
            </div>
            <div class="list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading"
                infinite-scroll-distance="10">
                <div class="item" v-for="(item, index) in dataList" :key="index">
                    <div class="name ellipsis">{{ item.sceneName }}</div>
                    <div class="info">
                        <div class="li">
                            <div class="name">触发条件：</div>
                            <div class="value ellipsis">{{ item.triggerCondition }}</div>
                        </div>
                        <div class="li">
                            <div class="name">执行动作：</div>
                            <div class="value ellipsis">{{ item.executeAction }}</div>
                        </div>
                        <div class="li">
                            <div class="name">生效时间：</div>
                            <div class="value ellipsis">
                                <template v-if="item.efficientProperty == '0'">全天</template>
                                <template v-else>
                                    {{
                item.efficientData.startTime +
                " - " +
                item.efficientData.endTime
            }}<template v-if="showCR(item)">(次日)</template>
                                </template>
                                -
                                <template v-if="item.efficientType != '4'">
                                    {{ backTxt2(item.efficientType) }}
                                </template>
                                <template v-else>
                                    {{ backWeekLabel(item.efficientData.type) }}
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="btn-view">
                        <img class="status-img" v-if="item.sceneState == '1'" src="@/assets/image/product/qiyong.png"
                            alt="" @click="statusClick(item)" />
                        <img class="status-img" v-else src="@/assets/image/product/jinyong.png" alt=""
                            @click="statusClick(item)" />
                        <div class="btn-right">
                            <div class="btn-item" @click="openDetails(item)">
                                <img src="@/assets/image/cloudscene/icon-ck.png" alt="" />
                                <div class="txt green">查看详情</div>
                            </div>
                            <div class="btn-item ml25" @click="openRename(item)">
                                <img src="@/assets/image/cloudscene/icon-cmm.png" alt="" />
                                <div class="txt green">重命名</div>
                            </div>
                            <div class="btn-item ml25" @click="bjClick(item)">
                                <img src="@/assets/image/cloudscene/icon-bj.png" alt="" />
                                <div class="txt yellow">编辑</div>
                            </div>
                            <div class="btn-item ml25" @click="deleteItem(item)">
                                <img src="@/assets/image/cloudscene/icon-sc.png" alt="" />
                                <div class="txt red">删除</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom bottom-no" v-else>
            <img class="table-noimg" src="@/assets/image/home/ZWT.png" alt="" />
            <div class="table-emptyword">暂未设置云端自动化</div>
            <div class="add-btn" @click="addClick">+ 新增</div>
        </div>
        <Addcloudscene ref="Addcloudscene" :triggerTypeList="triggerTypeList" :timingTypeList="timingTypeList"
            :weekTypeList="weekTypeList" :dateTypeList="dateTypeList" @Loaddata="getDataList"></Addcloudscene>
        <CloudsceneLogs ref="CloudsceneLogs" :triggerTypeList="triggerTypeList" :timingTypeList="timingTypeList"
            :weekTypeList="weekTypeList"></CloudsceneLogs>
        <Details ref="Details" :triggerTypeList="triggerTypeList" :timingTypeList="timingTypeList"
            :weekTypeList="weekTypeList">
        </Details>
        <Rename ref="Rename" @change="renameChange"></Rename>
        <Msg ref="tsmsg"></Msg>
    </div>
</template>

<script>
import Addcloudscene from "./addcloudscene.vue";
import CloudsceneLogs from "./cloudsceneLogs.vue";
import Details from "./details.vue";
import Rename from "./rename.vue";
import Msg from "@/components/msg.vue"; //信息提示组件
export default {
    components: { Addcloudscene, CloudsceneLogs, Details, Rename, Msg },

    data() {
        return {
            //表单参数
            paramsFrom: {
                sceneName: "",
                sceneState: "",
            },
            collectList: [
                {
                    name: "停用",
                    value: "0",
                },
                {
                    name: "启用",
                    value: "1",
                },
            ],
            dataList: [],
            triggerTypeList: [],
            timingTypeList: [],
            weekTypeList: [],
            dateTypeList: [],
        };
    },
    created() {
        this.getDataList();
        this.gettriggerTypeList();
        this.gettimingTypeList();
        this.getweekTypeList();
        this.getdateTypeList();
    },
    methods: {
        searchClick() {
            this.getDataList();
        },
        resetClick() {
            this.paramsFrom.sceneName = "";
            this.paramsFrom.sceneState = "";
            this.getDataList();
        },
        loadMore() {
            console.log("到底了");
        },
        addClick() {
            this.$refs.Addcloudscene.open("0");
        },
        bjClick(item) {
            this.$refs.Addcloudscene.open("1", item);
        },
        openLogs() {
            this.$refs.CloudsceneLogs.open();
        },
        openDetails(item) {
            this.$refs.Details.open(item);
        },
        openRename(item) {
            this.$refs.Rename.open(item);
        },
        renameChange(result) {
            console.log(result);
            if (result.resultObj.code == 200) {
                this.$refs.tsmsg.msgShow("修改成功", 1.5);
                this.dataList.forEach((item) => {
                    if (item.id == result.item.id) {
                        item.sceneName = result.item.sceneName;
                    }
                });
                this.$forceUpdate();
            } else {
                this.$refs.tsmsg.msgShow(result.resultObj.msg, 1.5);
            }
        },
        deleteItem(item) {
            this.$confirm("是否删除所选云端自动化内容", "删除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                customClass: "del-cloudscene",
            })
                .then(() => {
                    const formData = new FormData();
                    formData.append("ids", [item.id]);
                    this.$http
                        .deleteAction2(this.$api.delcloudscene, formData)
                        .then((res) => {
                            if (res.code == 200) {
                                this.getDataList();
                                this.$refs.tsmsg.msgShow("操作成功", 1.5);
                            } else {
                                this.$refs.tsmsg.msgShow(res.msg, 1.5);
                            }
                        });
                })
                .catch(() => { });
        },
        // 获取云场景列表
        getDataList() {
            let params = {
                page: 1,
                limit: 1000,
                sceneName: this.paramsFrom.sceneName,
                sceneState: this.paramsFrom.sceneState,
            };
            this.$http.postAction(this.$api.cloudscenelist, params).then((res) => {
                if (res.data && res.data.records) {
                    res.data.records.forEach((item) => {
                        if (item.efficientProperty == "1" || item.efficientType == "4") {
                            item.efficientData = JSON.parse(item.efficientData);
                        }
                    });
                    this.dataList = res.data.records;
                } else {
                    this.dataList = [];
                }
            });
        },
        // 禁用启用
        statusClick(item) {
            this.$http
                .postAction(this.$api.cloudsceneupdatestate + "?id=" + item.id)
                .then((res) => {
                    if (res.code == 200) {
                        item.sceneState = item.sceneState == "1" ? "0" : "1";
                        this.$refs.tsmsg.msgShow("操作成功", 1.5);
                    } else {
                        this.$refs.tsmsg.msgShow(res.msg, 1.5);
                    }
                    this.$forceUpdate();
                });
        },
        // 获取触发类型列表
        gettriggerTypeList() {
            let params = {
                dictCode: "trigger_type",
            };
            this.$http.getAction(this.$api.dictCode, params).then((res) => {
                if (res.data) {
                    this.triggerTypeList = res.data;
                }
            });
        },
        // 获取重复类型
        gettimingTypeList() {
            let params = {
                dictCode: "timing_type",
            };
            this.$http.getAction(this.$api.dictCode, params).then((res) => {
                if (res.data) {
                    this.timingTypeList = res.data;
                }
            });
        },
        // 获取星期
        getweekTypeList() {
            let params = {
                dictCode: "week_type",
            };
            this.$http.getAction(this.$api.dictCode, params).then((res) => {
                if (res.data) {
                    this.weekTypeList = res.data;
                }
            });
        },
        // 获取时间类型
        getdateTypeList() {
            let params = {
                dictCode: "date_type",
            };
            this.$http.getAction(this.$api.dictCode, params).then((res) => {
                if (res.data) {
                    this.dateTypeList = res.data;
                }
            });
        },
        // 是否显示次日
        showCR(item) {
            console.log("执行");
            if (
                !this.compareTimes(
                    item.efficientData.startTime,
                    item.efficientData.endTime
                )
            ) {
                return true;
            }
            return false;
        },
        compareTimes(time1, time2) {
            if (time1 == "") {
                return true;
            }
            if (time2 == "") {
                return true;
            }
            // 获取今天的日期
            const now = new Date();

            // 将时间字符串转换为 Date 对象，并假设日期是今天
            const time1Date = new Date(now.toDateString() + " " + time1);
            const time2Date = new Date(now.toDateString() + " " + time2);

            // 返回比较结果，true 表示 time1 早于 time2
            return time1Date < time2Date;
        },
        backTxt2(operateType) {
            let arr = this.timingTypeList.filter((item) => {
                return item.dictValue == operateType;
            });
            if (!arr.length) {
                return null;
            }
            return arr[0].dictLabel;
        },
        // 返回星期几
        backWeekLabel(params) {
            console.log(params);
            let arr = [];
            let indexArr = params.split(",");
            indexArr.sort((a, b) => a - b);
            indexArr.forEach((item) => {
                if (this.weekTypeList[item]) {
                    arr.push(this.weekTypeList[item].dictLabel);
                }
            });
            if (arr.length == 7) {
                return "每天";
            }
            return arr.join(",");
        },
    },
};
</script>

<style lang="scss" scoped>
.cloudscene-view {
    height: 100%;
    min-height: 610px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .top-box {
        height: 8%;
        background: #ffffff;
        border-radius: 0.125rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding-right: 0.275rem;

        .dc-btn {
            cursor: pointer;
            width: 1.05rem;
            height: 0.45rem;
            background: #42b5b2;
            border-radius: 0.1rem;
            text-align: center;
            line-height: 0.45rem;
            color: #ffffff;
            font-size: 0.175rem;
        }

        .cz-btn {
            margin-left: 0.2375rem;
            cursor: pointer;
            width: 1.1rem;
            height: 0.4625rem;
            border-radius: 0.1rem;
            border: 1px solid rgba(153, 153, 153, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
        }
    }

    .bottom {
        position: relative;
        height: 89.4%;
        background: #ffffff;
        border-radius: 0.125rem;
        box-sizing: border-box;
        padding: 0.25rem;
        display: flex;
        flex-direction: column;

        .bot-top {
            display: flex;

            .item {
                margin-right: 0.225rem;
                cursor: pointer;
                width: 0.975rem;
                height: 0.45rem;
                background: #2daea9;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #feffff;
            }
        }

        .list {
            margin-top: 0.275rem;
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            overflow: auto;

            .item {
                margin-right: 1.5%;
                margin-top: 0.275rem;
                width: 32%;
                height: 3.2625rem;
                background: #ffffff;
                border-radius: 10px;
                border: 1px solid #e4e4e4;
                box-sizing: border-box;
                padding: 0.375rem;
                padding-bottom: 0.2125rem;
                display: flex;
                flex-direction: column;

                &:nth-child(1),
                &:nth-child(2),
                &:nth-child(3) {
                    margin-top: 0;
                }

                &:nth-child(3n) {
                    margin-right: 0;
                }

                .name {
                    text-align: left;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    font-size: 0.2rem;
                    color: #333333;
                }

                .info {
                    flex: 1;
                    border-bottom: 1px solid #e4e4e4;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    box-sizing: border-box;
                    padding: 0.475rem 0 0.35rem 0;

                    .li {
                        display: flex;
                        align-items: center;

                        .name {
                            width: 1rem;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                        }

                        .value {
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            flex: 1;
                            text-align: right;
                        }
                    }
                }

                .btn-view {
                    margin-top: 0.2rem;
                    height: 0.375rem;
                    display: flex;
                    justify-content: space-between;

                    .status-img {
                        cursor: pointer;
                        width: 0.875rem;
                        height: 0.375rem;
                    }

                    .btn-right {
                        display: flex;

                        .btn-item {
                            cursor: pointer;
                            display: flex;
                            align-items: center;

                            .img {}

                            .txt {
                                margin-left: 6px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                            }

                            .green {
                                color: #2daea9;
                            }

                            .yellow {
                                color: #ffbb04;
                            }

                            .red {
                                color: #e64343;
                            }
                        }

                        .ml25 {
                            margin-left: 0.3125rem;
                        }
                    }
                }
            }
        }
    }

    .bottom-no {
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .table-noimg {
            width: 3rem;
        }

        .table-emptyword {
            margin-top: 0.1875rem;
            margin-bottom: 0.225rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 0.175rem;
            color: #999999;
        }

        .add-btn {
            cursor: pointer;
            width: 0.8875rem;
            height: 0.35rem;
            border-radius: 0.175rem;
            border: 1px solid #2daea9;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #2daea9;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>